// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__NN8A2","noInteraction":"EventWrapper_noInteraction__3iDZA"};